"use client";

import AnimateOnScroll from "./AnimateOnScroll";
import CustomButton from "./CustomButton";
import { TeamMemberCard } from "./OurTeam";
import { teamMembers } from "@/lib/teamMembers";
import { SITE_URL, ORGANIZATION_NAME } from "@/lib/metadata";
import { trackBookAppointmentClicked } from "@/lib/analytics";

const teamSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Our Sydney Team",
  itemListElement: teamMembers.map((member, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "Person",
      name: member.name,
      jobTitle: member.title,
      description: member.description,
      image: new URL(member.image, SITE_URL).href,
      url: new URL(`/teams/${member.slug.toLowerCase()}`, SITE_URL).href,
      worksFor: {
        "@type": "Organization",
        name: ORGANIZATION_NAME,
        url: SITE_URL,
      },
    },
  })),
};

const SydneyTeam = () => {
  return (
    <section className="w-full bg-white" aria-labelledby="sydney-team-heading">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(teamSchema).replace(/</g, "\\u003c"),
        }}
      />
      <div className="container">
        <AnimateOnScroll className="mb-8 flex flex-col items-center gap-2 text-center sm:mb-10 sm:gap-3 md:mb-12 md:gap-4 lg:mb-16">
          <span
            data-from-left
            className="font-crimsonText text-[20px] font-bold leading-none text-[#2857A7] sm:text-[24px] md:text-[28px]"
          >
            Meet Our Sydney Team
          </span>
          <h2 id="sydney-team-heading" className="heading text-v3-secondary">
            Our Therapy & Allied Health Team in Sydney
          </h2>
          <p className="max-w-[900px] font-onest text-[14px] font-normal leading-[1.7] text-black/60 sm:text-[15px]">
            Our multidisciplinary team of qualified counsellors, registered
            psychologists, and occupational therapists delivers compassionate,
            evidence-based care across Sydney. We combine clinical expertise
            with a client-centered approach to help you overcome life
            challenges, improve daily functioning, and achieve lasting mental
            wellbeing.
          </p>
          <div className="mt-2 flex flex-wrap items-center justify-center gap-3 sm:mt-4">
            <CustomButton
              label="About Us"
              href="/about"
              variant="primary"
              theme="blue"
              onClick={() =>
                trackBookAppointmentClicked({ location: "sydney_team" })
              }
            />
            <CustomButton
              label="View our Therapists"
              href="/teams"
              variant="secondary"
              theme="blue"
            />
          </div>
        </AnimateOnScroll>

        <div className="flex flex-col items-center justify-center gap-5 md:flex-row">
          {teamMembers.map((member) => (
            <TeamMemberCard key={member.slug} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SydneyTeam;
